'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _CompanyImage = require('../CompanyImage/CompanyImage');var _CompanyImage2 = _interopRequireDefault(_CompanyImage);
var _CompanyDescription = require('./CompanyDescription.scss');var styles = _interopRequireWildcard(_CompanyDescription);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CompanyDescription = function CompanyDescription(_ref) {var translate = _ref.translate,title = _ref.title,children = _ref.children,image = _ref.image;return (
    _react2.default.createElement('div', { className: styles.descriptionWrapper },
      _react2.default.createElement(_CompanyImage2.default, { image: image, alt: name }),
      _react2.default.createElement('div', { className: styles.infoBlock },
        _react2.default.createElement('div', { className: styles.nameCompany },
          title),

        _react2.default.createElement('div', { className: styles.description },
          _react2.default.createElement('p', null, translate('companyInPropertiesList', 'description')),
          _react2.default.createElement('p', null, translate('companyInPropertiesList', 'descriptionCTA'))),

        children)));};




CompanyDescription.propTypes = {
  translate: _propTypes2.default.func,
  title: _propTypes2.default.string,
  children: _propTypes2.default.node,
  image: _propTypes2.default.string };exports.default =


CompanyDescription;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyInPropertiesList/CompanyDescription/CompanyDescription.js
// module id = 2635
// module chunks = 0